var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCheck(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.1334 3.90546C10.0831 3.85469 10.0232 3.8144 9.95717 3.7869C9.89116 3.7594 9.82036 3.74524 9.74885 3.74524C9.67735 3.74524 9.60655 3.7594 9.54054 3.7869C9.47453 3.8144 9.41463 3.85469 9.36427 3.90546L5.32885 7.9463L3.63344 6.24546C3.58115 6.19496 3.51944 6.15525 3.45181 6.1286C3.38418 6.10194 3.31196 6.08887 3.23928 6.09013C3.1666 6.09139 3.09488 6.10695 3.02821 6.13592C2.96154 6.1649 2.90123 6.20672 2.85073 6.25901C2.80022 6.31129 2.76051 6.37301 2.73386 6.44064C2.70721 6.50827 2.69414 6.58048 2.6954 6.65316C2.69665 6.72585 2.71221 6.79757 2.74119 6.86423C2.77016 6.9309 2.81199 6.99121 2.86427 7.04171L4.94427 9.12171C4.99463 9.17248 5.05453 9.21278 5.12054 9.24028C5.18655 9.26778 5.25735 9.28194 5.32885 9.28194C5.40036 9.28194 5.47116 9.26778 5.53717 9.24028C5.60317 9.21278 5.66308 9.17248 5.71344 9.12171L10.1334 4.70171C10.1884 4.65099 10.2323 4.58943 10.2623 4.52091C10.2923 4.45239 10.3078 4.37839 10.3078 4.30359C10.3078 4.22878 10.2923 4.15479 10.2623 4.08627C10.2323 4.01775 10.1884 3.95619 10.1334 3.90546Z",
    fill: "white",
    stroke: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheck);
export default __webpack_public_path__ + "static/media/check.5e1efb9f70754c2246428d973b318a2b.svg";
export { ForwardRef as ReactComponent };